const SuccessMessage = ({ message, className = "" }) => {
  if (!message) return null;

  return (
    <div className={`success-message ${className}`} role="alert">
      <span className="success-icon">✅</span>
      <span className="success-text">{message}</span>
    </div>
  );
};

export default SuccessMessage;
